import axios from "axios";

const state = {
    industryPromise: null,
    market_areaPromise: null,
    sales_classPromise: null,
};

const mutations = {
    setIndustryPromise(state, promise) {
        state.industryPromise = promise;
    },
    setMarket_areaPromise(state, promise) {
        state.market_areaPromise = promise;
    },
    setSales_classPromise(state, promise) {
        state.sales_classPromise = promise;
    },
};

const actions = {
    async getIndustry({ commit, dispatch, state }, params) {
        if (state.industryPromise) {
            return state.industryPromise;
        }

        let currentSession = localStorage.getItem(
            'vue-authenticate.vueauth_access_token'
        );

        var axiosPromise = axios
            .post(
                process.env.VUE_APP_API_BASE_URL + '/user/favorites/get',
                {},
                {
                    params: {
                        session_id: currentSession,
                        category1: 'universal',
                        category2: 'industry',
                    },
                }
            )
            .then((res) => {
                if (res.hasOwnProperty('data') && res.data.error) {
                    commit('SET_ERROR_BIT', true);
                    commit(
                        'SET_ERROR_INFO',
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode +
                        `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/get" <br>`
                    );
                    throw new Error(
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode
                    );
                }
                return res;
            });

        commit('setIndustryPromise', axiosPromise);
        return axiosPromise;
    },

    async getMarketArea({ commit, dispatch, state }, params) {
        if (state.market_areaPromise) {
            return state.market_areaPromise;
        }

        let currentSession = localStorage.getItem(
            'vue-authenticate.vueauth_access_token'
        );

        var axiosPromise = axios
            .post(
                process.env.VUE_APP_API_BASE_URL + '/user/favorites/get',
                {},
                {
                    params: {
                        session_id: currentSession,
                        category1: 'universal',
                        category2: 'market_area',
                    },
                }
            )
            .then((res) => {
                if (res.hasOwnProperty('data') && res.data.error) {
                    commit('SET_ERROR_BIT', true);
                    commit(
                        'SET_ERROR_INFO',
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode +
                        `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/get" <br>`
                    );
                    throw new Error(
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode
                    );
                }
                return res;
            });

        commit('setMarket_areaPromise', axiosPromise);
        return axiosPromise;
    },

    async getSalesClass({ commit, dispatch, state }, params) {
        if (state.sales_classPromise) {
            return state.sales_classPromise;
        }

        let currentSession = localStorage.getItem(
            'vue-authenticate.vueauth_access_token'
        );

        var axiosPromise = axios
            .post(
                process.env.VUE_APP_API_BASE_URL + '/user/favorites/get',
                {},
                {
                    params: {
                        session_id: currentSession,
                        category1: 'universal',
                        category2: 'sales_class',
                    },
                }
            )
            .then((res) => {
                if (res.hasOwnProperty('data') && res.data.error) {
                    commit('SET_ERROR_BIT', true);
                    commit(
                        'SET_ERROR_INFO',
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode +
                        `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/get" <br>`
                    );
                    throw new Error(
                        '<br>' +
                        'Server responded with error = True <br> errorCode: ' +
                        res.data.errorCode
                    );
                }
                return res;
            });

        commit('setSales_classPromise', axiosPromise);
        return axiosPromise;
    },
};

const favorite = {
    namespaced: true,
    state,
    mutations,
    actions,
};

export default favorite;